import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'tran-checkbox-tree-item',
    imports: [TranslatePipe],
    templateUrl: './checkbox-tree-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'block min-w-0' }
})
export class CheckboxTreeItemComponent {
    public readonly label = input.required<string>();
    public readonly isCategory = input(false);
    public readonly selectedCount = input(0);
    public readonly totalCount = input(0);
}
